import { $, component$, Resource, useResource$ } from "@builder.io/qwik";
import { Card, CardContent, CardHeader } from "./ui/card";
import { CDNImage } from "./ui/cdn-image";
import type { CcoSelect } from "~/lib/schemas";
import { SimpleCarousel } from "./ui/simple-carousel";
import { getCcos } from "~/lib/ccos";

export const CcoCarousel = component$(() => {
  const ccos = useResource$(() => getCcos(12));

  const renderCcoCard$ = $((cco: CcoSelect | null) => (
    <Card class="h-full">
      {cco ? (
        <>
          <CardHeader>
            <div class="flex h-12 items-start gap-4">
              {cco.logoUrl && (
                <div class="flex h-12 w-12 flex-shrink-0 items-center justify-center overflow-hidden rounded-md bg-gray-100">
                  <CDNImage
                    src={cco.logoUrl}
                    alt={`${cco.name} logo`}
                    class="h-full w-full object-contain"
                    width={64}
                    height={64}
                  />
                </div>
              )}
              <h3 class="font-heading text-primary text-lg font-medium leading-none">
                {cco.name}
              </h3>
            </div>
          </CardHeader>
          <CardContent>
            <p class="text-tertiary line-clamp-3 text-sm">{cco.description}</p>
          </CardContent>
        </>
      ) : (
        <CardContent class="flex h-full w-full items-center justify-center">
          <p class="text-tertiary text-sm">And dozens more...</p>
        </CardContent>
      )}
    </Card>
  ));

  return (
    <Resource
      value={ccos}
      onResolved={(ccos) => (
        <SimpleCarousel
          items={[...ccos.ccos, null]}
          renderItem={renderCcoCard$}
        />
      )}
    />
  );
});
